// Minimal stroke icon set (24px grid). "c:" = circle cx cy r, "r:" = rect x y w h rx.
const ICONS = {
  hash: ['M4 9h16', 'M4 15h16', 'M10 3 8 21', 'M16 3l-2 18'],
  lock: ['r:4 11 16 10 2', 'M8 11V7a4 4 0 0 1 8 0v4'],
  plus: ['M12 5v14', 'M5 12h14'],
  search: ['c:11 11 7', 'm20 20-4-4'],
  x: ['M18 6 6 18', 'M6 6l12 12'],
  chevronDown: ['m6 9 6 6 6-6'],
  chevronLeft: ['m15 18-6-6 6-6'],
  chevronRight: ['m9 18 6-6-6-6'],
  smile: ['c:12 12 9', 'M8 14s1.5 2 4 2 4-2 4-2', 'M9 9h.01', 'M15 9h.01'],
  smilePlus: ['M22 11v1a10 10 0 1 1-9-10', 'M8 14s1.5 2 4 2 4-2 4-2', 'M9 9h.01', 'M15 9h.01', 'M16 5h6', 'M19 2v6'],
  paperclip: ['m21.4 11-9.2 9.2a6 6 0 0 1-8.5-8.5l8.6-8.6A4 4 0 1 1 18 8.8l-8.6 8.6a2 2 0 0 1-2.8-2.8l8.5-8.5'],
  send: ['m22 2-7 20-4-9-9-4Z', 'M22 2 11 13'],
  pencil: ['M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z'],
  compose: ['M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7', 'M18.4 2.6a2.17 2.17 0 0 1 3 3L12 15l-4 1 1-4Z'],
  trash: ['M3 6h18', 'M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6', 'M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2'],
  pin: ['M12 17v5', 'M9 10.8a2 2 0 0 1-1.1 1.8l-1.8.9A2 2 0 0 0 5 15.2V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.8a2 2 0 0 0-1.1-1.8l-1.8-.9a2 2 0 0 1-1.1-1.8V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z'],
  link: ['M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7', 'M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7'],
  more: ['c:12 12 1', 'c:19 12 1', 'c:5 12 1'],
  thread: ['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'],
  at: ['c:12 12 4', 'M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8'],
  bell: ['M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9', 'M10.3 21a1.94 1.94 0 0 0 3.4 0'],
  bellOff: ['M8.7 3A6 6 0 0 1 18 8a21 21 0 0 0 .6 5', 'M17 17H3s3-2 3-9a4.7 4.7 0 0 1 .3-1.7', 'M10.3 21a1.94 1.94 0 0 0 3.4 0', 'm2 2 20 20'],
  users: ['M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', 'c:9 7 4', 'M22 21v-2a4 4 0 0 0-3-3.9', 'M16 3.1a4 4 0 0 1 0 7.8'],
  user: ['M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2', 'c:12 7 4'],
  userPlus: ['M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', 'c:9 7 4', 'M19 8v6', 'M22 11h-6'],
  info: ['c:12 12 9', 'M12 16v-4', 'M12 8h.01'],
  sliders: ['M4 21v-7', 'M4 10V3', 'M12 21v-9', 'M12 8V3', 'M20 21v-5', 'M20 12V3', 'M1 14h6', 'M9 8h6', 'M17 16h6'],
  logout: ['M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', 'm16 17 5-5-5-5', 'M21 12H9'],
  file: ['M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5z', 'M14 2v6h6'],
  download: ['M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4', 'm7 10 5 5 5-5', 'M12 15V3'],
  clock: ['c:12 12 9', 'M12 7v5l3 2'],
  bookmark: ['m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z'],
  check: ['M20 6 9 17l-5-5'],
  archive: ['r:2 3 20 5 1', 'M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8', 'M10 12h4'],
  home: ['m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z', 'M9 22V12h6v10'],
  menu: ['M4 6h16', 'M4 12h16', 'M4 18h16'],
  bold: ['M6 4h8a4 4 0 0 1 0 8H6z', 'M6 12h9a4 4 0 0 1 0 8H6z'],
  italic: ['M19 4h-9', 'M14 20H5', 'M15 4 9 20'],
  strike: ['M16 4H9a3 3 0 0 0-2.8 4', 'M14 12a4 4 0 0 1 0 8H6', 'M4 12h16'],
  code: ['m16 18 6-6-6-6', 'm8 6-6 6 6 6'],
  external: ['M15 3h6v6', 'M10 14 21 3', 'M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6'],
  image: ['r:3 3 18 18 2', 'c:9 9 2', 'm21 15-3-3a2 2 0 0 0-2.8 0L6 21'],
  copy: ['r:8 8 14 14 2', 'M4 16a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2'],
  moon: ['M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z'],
  dot: ['c:12 12 3'],
  arrowUp: ['m5 12 7-7 7 7', 'M12 19V5'],
  laptop: ['M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9', 'M2 19h20', 'M4 16h16l2 3H2z'],
  phone: ['r:6 2 12 20 2.5', 'M11 18h2'],
  share: ['M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8', 'm16 6-4-4-4 4', 'M12 2v13'],
  plusSquare: ['r:3 3 18 18 3', 'M8 12h8', 'M12 8v8'],
  calendar: ['r:3 4 18 18 2', 'M16 2v4', 'M8 2v4', 'M3 10h18'],
  sparkles: ['M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z', 'M19 3v4', 'M17 5h4', 'M5 17v3', 'M3.5 18.5h3'],
  star: ['M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z'],
  folder: ['M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z'],
  sort: ['m21 16-4 4-4-4', 'M17 20V4', 'm3 8 4-4 4 4', 'M7 4v16'],
  eye: ['M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z', 'c:12 12 3'],
  door: ['M13 4h3a2 2 0 0 1 2 2v14', 'M2 20h3', 'M13 20h9', 'M10 12v.01', 'M13 4.6v16.2a1 1 0 0 1-1.2 1L5 20V5.6a2 2 0 0 1 1.5-1.9l5-1.2A1 1 0 0 1 13 4.6Z'],
} as const

export type IconName = keyof typeof ICONS

export function Icon({ name, size = 18, className, strokeWidth = 2 }: { name: IconName; size?: number; className?: string; strokeWidth?: number }) {
  return (
    <svg
      className={className ? `icon ${className}` : 'icon'}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {ICONS[name].map((d, i) => {
        if (d.startsWith('c:')) {
          const [cx, cy, r] = d.slice(2).split(' ')
          return <circle key={i} cx={cx} cy={cy} r={r} />
        }
        if (d.startsWith('r:')) {
          const [x, y, w, h, rx] = d.slice(2).split(' ')
          return <rect key={i} x={x} y={y} width={w} height={h} rx={rx} />
        }
        return <path key={i} d={d} />
      })}
    </svg>
  )
}

/** The Assembly mark: the Slack pinwheel, drawn in currentColor. */
export function Logo({ size = 28 }: { size?: number }) {
  const piece = (
    <>
      <rect x="0.7" y="33.7" width="59.4" height="26.4" rx="13.2" />
      <path d="M60.2 27H47a13.2 13.2 0 1 1 13.2-13.2z" />
    </>
  )
  return (
    <svg width={size} height={size} viewBox="0 0 127 127" fill="currentColor" aria-label="Assembly">
      {[0, 90, 180, 270].map((a) => (
        <g key={a} transform={`rotate(${a} 63.5 63.5)`}>
          {piece}
        </g>
      ))}
    </svg>
  )
}
